const CloudNationLogo = () => (
  <img
    // src="/CloudNationLogo.png"
    src="/hu-logo.svg"
    alt="CloudNation Logo"
    className="h-8 w-auto"
  />
);

export default CloudNationLogo;
